import React, { useContext } from 'react';
import { AppDivisionContext } from '../../contexts/AppDivisionContext';
import DivisionError from '../Shared/DivisionError/DivisionError';
import AssetStatusesAdmin from './AssetStatusesAdmin';
import AssetTypesAdmin from './AssetTypesAdmin';

const AssetTypesPage: React.FC = () => {
  const { appDivisionId } = useContext(AppDivisionContext);

  if (!appDivisionId) {
    return <DivisionError resource='asset types' />;
  }

  return (
    <div className='asset-types-page'>
      <AssetStatusesAdmin divisionId={appDivisionId} />
      <AssetTypesAdmin divisionId={appDivisionId} />
    </div>
  );
};

export default AssetTypesPage;
